import template from './users-filter.html';
import UsersFilterController from './users-filter.controller';
import './users-filter.styl';

let usersFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template,
  controller: UsersFilterController,
  controllerAs: 'vm'
};

export default usersFilterComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/users-filter/users-filter.component.js
 **/